export default [
	{
		path: '/organization/new',
		name: 'new-organization',
		// Redirect to account settings organization section to create new organization.
		redirect: { path: '/myaccount', hash: '#organizations' },
		meta: {
			auth: 'required'
		}
	}
];
